import { Injectable } from '@angular/core';
import {
  BankTransferSubscriptionItems,
  SummaryDTO,
  UpdateSubscriptionItemsDTO,
} from '../../accounts/types';

@Injectable()
export class CheckoutHelperService {
  extractItemsFromSummary(
    summary: SummaryDTO,
    coupons: string[],
  ): UpdateSubscriptionItemsDTO {
    const subscriptionItems: BankTransferSubscriptionItems[] = [];
    const couponIds: string[] = [];
    if (summary.plan) {
      subscriptionItems.push({
        itemPriceId: summary.plan.itemPriceId,
        quantity: summary.plan.quantity,
        originalQuantity: summary.plan.originalQuantity,
        period: summary.plan.period,
        price: +summary.plan.amount.toFixed(2),
        type: summary.plan.type,
        itemLevelDiscount: summary.plan.itemLevelDiscount,
        discountAmount: summary.plan.discountAmount,
        basePlanId: summary.plan.itemId,
      });
    }

    if (summary.location) {
      subscriptionItems.push({
        itemPriceId: summary.location.itemPriceId,
        quantity: summary.location.quantity,
        originalQuantity: summary.location.originalQuantity,
        period: summary.location.period,
        price: +summary.location.amount.toFixed(2),
        type: summary.location.type,
        itemLevelDiscount: summary.location.itemLevelDiscount,
        discountAmount: summary.location.discountAmount,
        basePlanId: summary.location.itemId,
      });
    }

    if (summary.users) {
      subscriptionItems.push({
        itemPriceId: summary.users.itemPriceId,
        quantity: summary.users.quantity,
        originalQuantity: summary.users.originalQuantity,
        period: summary.users.period,
        price: +summary.users.amount.toFixed(2),
        type: summary.users.type,
        itemLevelDiscount: summary.users.itemLevelDiscount,
        discountAmount: summary.users.discountAmount,
        basePlanId: summary.users.itemId,
      });
    }

    if (summary.registers) {
      subscriptionItems.push({
        itemPriceId: summary.registers.itemPriceId,
        quantity: summary.registers.quantity,
        originalQuantity: summary.registers.originalQuantity,
        period: summary.registers.period,
        price: +summary.registers.amount.toFixed(2),
        type: summary.registers.type,
        itemLevelDiscount: summary.registers.itemLevelDiscount,
        discountAmount: summary.registers.discountAmount,
        basePlanId: summary.registers.itemId,
      });
    }

    if (summary.fullStackAccounting) {
      subscriptionItems.push({
        itemPriceId: summary.fullStackAccounting.itemPriceId,
        quantity: summary.fullStackAccounting.quantity,
        originalQuantity: summary.fullStackAccounting.originalQuantity,
        period: summary.fullStackAccounting.period,
        price: +summary.fullStackAccounting.amount.toFixed(2),
        type: summary.fullStackAccounting.type,
        itemLevelDiscount: summary.fullStackAccounting.itemLevelDiscount,
        discountAmount: summary.fullStackAccounting.discountAmount,
        basePlanId: summary.fullStackAccounting.itemId,
      });
    }

    if (summary.fbBundle) {
      subscriptionItems.push({
        itemPriceId: summary.fbBundle.itemPriceId,
        quantity: summary.fbBundle.quantity,
        originalQuantity: summary.fbBundle.originalQuantity,
        period: summary.fbBundle.period,
        price: +summary.fbBundle.amount.toFixed(2),
        type: summary.fbBundle.type,
        itemLevelDiscount: summary.fbBundle.itemLevelDiscount,
        discountAmount: summary.fbBundle.discountAmount,
        basePlanId: summary.fbBundle.itemId,
      });
    }

    if (summary.whatsAppIntegration) {
      subscriptionItems.push({
        itemPriceId: summary.whatsAppIntegration.itemPriceId,
        quantity: summary.whatsAppIntegration.quantity,
        originalQuantity: summary.whatsAppIntegration.originalQuantity,
        period: summary.whatsAppIntegration.period,
        price: +summary.whatsAppIntegration.amount.toFixed(2),
        type: summary.whatsAppIntegration.type,
        itemLevelDiscount: summary.whatsAppIntegration.itemLevelDiscount,
        discountAmount: summary.whatsAppIntegration.discountAmount,
        basePlanId: summary.whatsAppIntegration.itemId,
      });
    }

    if (summary.grubtech) {
      subscriptionItems.push({
        itemPriceId: summary.grubtech.itemPriceId,
        quantity: summary.grubtech.quantity,
        originalQuantity: summary.grubtech.originalQuantity,
        period: summary.grubtech.period,
        price: +summary.grubtech.amount.toFixed(2),
        type: summary.grubtech.type,
        itemLevelDiscount: summary.grubtech.itemLevelDiscount,
        discountAmount: summary.grubtech.discountAmount,
        basePlanId: summary.grubtech.itemId,
      });
    }

    if (summary.kds) {
      subscriptionItems.push({
        itemPriceId: summary.kds.itemPriceId,
        quantity: summary.kds.quantity,
        originalQuantity: summary.kds.originalQuantity,
        period: summary.kds.period,
        price: +summary.kds.amount.toFixed(2),
        type: summary.kds.type,
        itemLevelDiscount: summary.kds.itemLevelDiscount,
        discountAmount: summary.kds.discountAmount,
        basePlanId: summary.kds.itemId,
      });
    }

    if (summary.whatsappInvoices1000) {
      subscriptionItems.push({
        itemPriceId: summary.whatsappInvoices1000.itemPriceId,
        quantity: summary.whatsappInvoices1000.quantity,
        originalQuantity: summary.whatsappInvoices1000.originalQuantity,
        period: summary.whatsappInvoices1000.period,
        price: +summary.whatsappInvoices1000.amount.toFixed(2),
        type: summary.whatsappInvoices1000.type,
        itemLevelDiscount: summary.whatsappInvoices1000.itemLevelDiscount,
        discountAmount: summary.whatsappInvoices1000.discountAmount,
        basePlanId: summary.whatsappInvoices1000.itemId,
      });
    }

    if (summary.whatsappInvoices5000) {
      subscriptionItems.push({
        itemPriceId: summary.whatsappInvoices5000.itemPriceId,
        quantity: summary.whatsappInvoices5000.quantity,
        originalQuantity: summary.whatsappInvoices5000.originalQuantity,
        period: summary.whatsappInvoices5000.period,
        price: +summary.whatsappInvoices5000.amount.toFixed(2),
        type: summary.whatsappInvoices5000.type,
        itemLevelDiscount: summary.whatsappInvoices5000.itemLevelDiscount,
        discountAmount: summary.whatsappInvoices5000.discountAmount,
        basePlanId: summary.whatsappInvoices5000.itemId,
      });
    }

    if (summary.whatsappInvoices50000) {
      subscriptionItems.push({
        itemPriceId: summary.whatsappInvoices50000.itemPriceId,
        quantity: summary.whatsappInvoices50000.quantity,
        originalQuantity: summary.whatsappInvoices50000.originalQuantity,
        period: summary.whatsappInvoices50000.period,
        price: +summary.whatsappInvoices50000.amount.toFixed(2),
        type: summary.whatsappInvoices50000.type,
        itemLevelDiscount: summary.whatsappInvoices50000.itemLevelDiscount,
        discountAmount: summary.whatsappInvoices50000.discountAmount,
        basePlanId: summary.whatsappInvoices50000.itemId,
      });
    }

    if (summary.applications) {
      summary.applications.forEach((application) => {
        subscriptionItems.push({
          itemPriceId: application.itemPriceId,
          quantity: application.quantity,
          originalQuantity: application.originalQuantity,
          period: application.period,
          price: +application.amount.toFixed(2),
          type: application.type,
          itemLevelDiscount: application.itemLevelDiscount,
          discountAmount: application.discountAmount,
          basePlanId: application.itemId,
        });
      });

      if (summary.charges) {
        summary.charges.forEach((charge) => {
          subscriptionItems.push({
            itemPriceId: charge.itemPriceId,
            quantity: charge.quantity,
            originalQuantity: charge.originalQuantity,
            period: charge.period,
            price: +charge.amount.toFixed(2),
            type: charge.type,
            itemLevelDiscount: charge.itemLevelDiscount,
            discountAmount: charge.discountAmount,
            basePlanId: charge.itemId,
          });
        });
      }
      if (coupons.length > 0) {
        couponIds.push(...coupons);
      }
    }

    return {
      subscriptionItems,
      nowInTrial: true,
      couponIds,
    };
  }
}
